import { Component, ElementRef, OnDestroy, OnInit, inject, input } from '@angular/core';
import { LoadingService } from 'src/app/services/loading.service';
import { I18nPipe } from 'src/app/shared/pipes/i18n.pipe';

@Component({
   selector: 'app-loading',
   standalone: true,
   imports: [I18nPipe],
   templateUrl: './loading.component.html',
   host: {
      '[class.app-loading--inline]': 'inline()',
      '[class.is-active]': 'loadingService.isLoading()',
   },
})
export class LoadingComponent implements OnInit, OnDestroy {
   private readonly elementRef = inject(ElementRef<HTMLElement>);
   readonly loadingService = inject(LoadingService);

   readonly hasBackgound = input<boolean>(true);
   readonly textLabel = input<string>();
   /** Mantém o loader no container pai (ex.: autocomplete). Sem isso, sobe para o body e fica acima de sheets/dialogs. */
   readonly inline = input<boolean>(false);

   ngOnInit(): void {
      if (!this.inline()) {
         try {
            document.body.appendChild(this.elementRef.nativeElement);
         } catch {
            /* ignore */
         }
      }
   }

   ngOnDestroy(): void {
      if (!this.inline()) {
         try {
            this.elementRef.nativeElement.remove();
         } catch {
            /* already detached */
         }
      }
   }
}
